import React from 'react';
import setupIcon from '../../../assets/1setup.svg';
import setupSelectedIcon from '../../../assets/1setup_select.svg';
import processIcon from '../../../assets/2process.svg';
import processSelectedIcon from '../../../assets/2process_select.svg';
import paperIcon from '../../../assets/3paper.svg';
import paperSelectedIcon from '../../../assets/3paper_select.svg';
import syncIcon from '../../../assets/4sync.svg';
import syncSelectedIcon from '../../../assets/4sync_select.svg';
import faqIcon from '../../../assets/5faq.svg';
import faqSelectedIcon from '../../../assets/5faq_select.svg';
import { Layout, Switch } from 'antd';

import styles from './index.css';
import { getConfiguredStaticURL } from '../../../config/runtime.js';

const { Content, Footer } = Layout;

interface VideoItem {
  readonly key: string;
  readonly label: string;
  readonly video: string;
  readonly parent: string;
}

interface MenuItem {
  readonly key: string;
  readonly icon: string;
  readonly selectIcon: string;
  readonly label: string;
  readonly children: readonly Omit<VideoItem, 'parent'>[];
}

const menuItems: readonly MenuItem[] = [
  {
    key: '安装及更新',
    icon: setupIcon,
    selectIcon: setupSelectedIcon,
    label: '安装及更新',
    children: [
      { key: '架构简介', label: '架构简介', video: '1-1.mp4' },
      { key: '下载安装', label: '下载安装', video: '1-2.mp4' },
      { key: '程序更新', label: '程序更新', video: '1-3.mp4' },
    ],
  },
  {
    key: '训练流程',
    icon: processIcon,
    selectIcon: processSelectedIcon,
    label: '训练流程',
    children: [
      { key: '训练计划', label: '训练计划', video: '2-1.mp4' },
      { key: '训练管理', label: '训练管理', video: '2-2.mp4' },
      { key: '终端管理', label: '终端管理', video: '2-3.mp4' },
    ],
  },
  {
    key: '学生操作',
    icon: paperIcon,
    selectIcon: paperSelectedIcon,
    label: '学生操作',
    children: [
      { key: '登录候考', label: '登录候考', video: '3-1.mp4' },
      { key: '答题操作', label: '答题操作', video: '3-2.mp4' },
      { key: '订正操作', label: '订正操作', video: '3-3.mp4' },
    ],
  },
  {
    key: '数据同步',
    icon: syncIcon,
    selectIcon: syncSelectedIcon,
    label: '数据同步',
    children: [
      { key: '对接平台', label: '对接平台', video: '4-1.mp4' },
      { key: '试卷班级', label: '试卷班级', video: '4-2.mp4' },
      { key: '成绩上报', label: '成绩上报', video: '4-3.mp4' },
    ],
  },
  {
    key: '常见问题',
    icon: faqIcon,
    selectIcon: faqSelectedIcon,
    label: '常见问题',
    children: [
      { key: '离线同步', label: '离线同步', video: '5-1.mp4' },
      { key: '断网处置', label: '断网处置', video: '5-2.mp4' },
      { key: '学生密码', label: '学生密码', video: '5-3.mp4' },
      { key: '课堂练习与自主练习模式切换', label: '课堂练习与自主练习模式切换', video: '5-4.mp4' },
      { key: '题库组卷与同步', label: '题库组卷与同步', video: '5-5.mp4' },
    ],
  },
];

const allVideos: readonly VideoItem[] = menuItems.flatMap((item) =>
  item.children.map((child) => ({ ...child, parent: item.label })),
);
const isMiniSize = window.innerWidth < 480;
const css = (name: string): string => styles[name] ?? '';

export default function VideoPage(): React.ReactElement {
  const [currentVideo, setCurrentVideo] = React.useState<VideoItem>(allVideos[0]!);
  const [autoPlay, setAutoPlay] = React.useState(true);
  const [isMobile, setIsMobile] = React.useState(isMiniSize);
  const currentVideoIndex = allVideos.findIndex((item) => item.key === currentVideo.key);

  React.useEffect(() => {
    const handleResize = (): void => setIsMobile(window.innerWidth < 480);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const goNext = (): void => {
    const nextVideo = allVideos[currentVideoIndex + 1];
    if (nextVideo) setCurrentVideo(nextVideo);
  };
  const goPrev = (): void => {
    const previousVideo = allVideos[currentVideoIndex - 1];
    if (previousVideo) setCurrentVideo(previousVideo);
  };

  return (
    <div>
      <div className={css('layout')}>
        <div className={css('sider')}>
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <img src="/deployment/brand_inv.png" alt="logo" style={{ width: '90px' }} />
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                fontSize: '16px',
                letterSpacing: '5px',
                marginLeft: '15px',
              }}
            >
              <div>模拟训练系统</div>
              <div>（机房版）</div>
            </div>
          </div>
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              marginTop: '10px',
              marginBottom: '20px',
            }}
          >
            <div style={{ fontSize: '26px', letterSpacing: '5px' }}>视频操作教程</div>
          </div>
          {menuItems.map((item) => {
            const labelSelected = currentVideo.parent === item.key;
            return (
              <div key={item.key} style={{ color: 'white', margin: '20px' }}>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <img
                    src={labelSelected ? item.selectIcon : item.icon}
                    alt={item.label}
                    style={{ height: '30px' }}
                  />
                  <div
                    style={{
                      fontSize: '20px',
                      marginLeft: '10px',
                      letterSpacing: '3px',
                      color: labelSelected ? '#fff' : '#838383',
                    }}
                  >
                    {item.label}
                  </div>
                </div>
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    marginTop: '5px',
                    cursor: 'pointer',
                    flexWrap: 'wrap',
                  }}
                >
                  {item.children.map((child) => (
                    <div
                      key={child.key}
                      style={{
                        fontSize: '16px',
                        color: currentVideo.key === child.key ? '#fff' : '#838383',
                        margin: '10px 0',
                      }}
                      onClick={() => {
                        setCurrentVideo({ ...child, parent: item.key });
                        document.getElementById('video')?.scrollIntoView({ behavior: 'smooth' });
                      }}
                    >
                      {child.label}
                    </div>
                  ))}
                </div>
              </div>
            );
          })}
        </div>
        <Layout>
          <Content style={{ margin: '24px 16px 0', maxHeight: '100vh', overflowY: 'auto' }}>
            <div className={css('siteLayoutBackground')}>
              <video
                id="video"
                src={getConfiguredStaticURL(`/file/pclab2/videos/${currentVideo.video}`)}
                controls
                autoPlay
                className={css('mainVideo')}
                onEnded={() => {
                  if (autoPlay) goNext();
                }}
              >
                您的浏览器不支持 video 标签。
              </video>
            </div>
          </Content>
          <Footer style={{ textAlign: 'center', padding: '20px 10px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              {currentVideoIndex === 0 ? (
                <div className={css('footerArrow')} />
              ) : (
                <div
                  className={css('footerArrow')}
                  onClick={goPrev}
                  title={allVideos[currentVideoIndex - 1]?.label}
                >{`< ${allVideos[currentVideoIndex - 1]?.label}`}</div>
              )}
              <div className={css('videoTitle')}>
                {isMobile ? (
                  <div>
                    <div style={{ fontWeight: 600 }}>{currentVideo.parent}</div>
                    <div>{currentVideo.label}</div>
                  </div>
                ) : (
                  `${currentVideo.parent} - ${currentVideo.label}`
                )}
              </div>
              {currentVideoIndex === allVideos.length - 1 ? (
                <div className={css('footerArrow')} />
              ) : (
                <div
                  className={css('footerArrow')}
                  onClick={goNext}
                  title={allVideos[currentVideoIndex + 1]?.label}
                >{`${allVideos[currentVideoIndex + 1]?.label} >`}</div>
              )}
            </div>
            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
              <div>
                <span style={{ marginRight: '5px', fontSize: '14px', letterSpacing: '5px' }}>
                  自动连播
                </span>
                <Switch
                  checkedChildren="开"
                  unCheckedChildren="关"
                  defaultChecked
                  checked={autoPlay}
                  onChange={setAutoPlay}
                />
              </div>
            </div>
          </Footer>
        </Layout>
      </div>
    </div>
  );
}
